module.exports = __webpack_public_path__ + "static/media/nuclearSclerosis.47695688.gif";